module.exports = __webpack_public_path__ + "static/img/empjf.e3ac2ec4.png";